export default {"src":"/_next/static/media/Female-05.0ded05bc.svg","height":96,"width":96,"blurWidth":0,"blurHeight":0};